// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg[data-v-86996128]{background:var(--v-loading-bg-base);opacity:.6;height:100%;width:100%;z-index:1;position:absolute;left:0;top:0}.bg div[data-v-86996128]{height:100vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
